<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a
        class="ant-dropdown-link"
        style="marginLeft:24px"
        @click.prevent="openConcat"
      >
          <img
            src="../../assets/icon／在线客服2.png"
            alt
            style="width:20px,height:20px"
          />
          <span style="marginLeft:4px">联系客服</span>
      </a>
      <a-dropdown style="marginLeft:24px">
        <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
          <a-icon type="user" />
          <span style="marginLeft:4px">{{ user.mobile }}</span>
        </a>
        <a-menu
          slot="overlay"
          style="top: 20px;min-width: 101px;text-align:center"
        >
          <a-menu-item
            key="0"
            @click="
              () => {
                $router.push('/account/base');
              }
            "
          >
            <span>个人中心</span>
          </a-menu-item>
          <a-menu-item key="1" @click="handleLogout">
            <span>退出登录</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <customer-service-modal
      ref="customerServiceModal"
      :wechat="baseData.wechat"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CustomerServiceModal from '@/components/CustomerServiceModal/index';

export default {
  name: 'UserMenu',
  components: {
    CustomerServiceModal
  },
  data() {
    return {
      baseData: baseData,
      user: this.userInfo()
    };
  },

  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['userInfo']),
    handleLogout() {
      const that = this;
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          return that
            .Logout({})
            .then(() => {
              // window.location.reload();
              // 客户端退出到clientLogin
              if (typeof window.client !== "undefined") {
                return (window.location.href = "/clientLogin");
              }
              // 后台退出登录跳转回首页
              window.location.href = '/index';
            })
            .catch((err) => {
              that.$message.error({
                title: '错误',
                description: err.message
              });
            });
        },
        onCancel() {}
      });
    },
    openConcat() {
      this.$refs.customerServiceModal.open();
    }
  }
};
</script>
<style lang="less" scoped>
.user-wrapper {
  a {
    color: #ffffff;
    opacity: 0.7;
  }
}
</style>
